import React from "react";

import { Dashboard, DashboardTabOptionComponentProps } from "api/model/dashboard/Dashboard";
import { Dropdown } from "primereact/dropdown";
import { Menu } from "primereact/menu";
import { SelectItem } from "primereact/selectitem";
import { Link } from "react-router-dom";
import { T } from "services/lang/LanguageService";
import { ArrowDirection } from "utils/enums";
import "../dashboard-styles/DashboardMain.scss";
import { getMenuItems } from "../utils";
import ArrowNavigationButtons from "./common/ArrowNavigationButtons";
import { useTabGroups } from "./common/useTabGroups";
import useTabNavigation from "./common/useTabNavigation";

const DashboardGroupDropdownTabRowMenu: React.FC<DashboardTabOptionComponentProps> = ({
  isMobile,
  menuRef,
  tabId,
  dashboard,
}) => {
  const { handleTabChange } = useTabNavigation(dashboard, isMobile);
  const { selectedTabGroupUUID, tabGroups, tabsInGroup, handleTabGroupChange, changeTabWithArrow } =
    useTabGroups(dashboard, tabId, handleTabChange);

  return (
    <div>
      {isMobile ? (
        <Menu
          ref={menuRef}
          model={getMenuItems(tabGroups, handleTabChange)}
          popup
          className="w-12 menu-list"
        />
      ) : (
        <div className="flex flex-row gap-2 items-center tabs-dropdown align-items-center">
          <Dropdown
            value={selectedTabGroupUUID}
            options={tabGroups}
            onChange={handleTabGroupChange}
            className="w-21rem"
            filter
            showFilterClear
            placeholder={T("action.select-group")}
          />
          {dashboard.showTabNavigation && (
            <ArrowNavigationButtons
              isPrevDisabled={tabGroups.findIndex(node => node.value === selectedTabGroupUUID) <= 0}
              isNextDisabled={
                tabGroups.findIndex(node => node.value === selectedTabGroupUUID) === tabGroups.length - 1
              }
              prevTooltip={T("action.select-previous-tab-group")}
              nextTooltip={T("action.select-next-tab-group")}
              onPrev={() => changeTabWithArrow(ArrowDirection.UP, tabGroups, selectedTabGroupUUID!, true)}
              onNext={() => changeTabWithArrow(ArrowDirection.DOWN, tabGroups, selectedTabGroupUUID!, true)}
            />
          )}
          <div className="tabsFlex">
            {tabsInGroup?.map(tab => (
              <DashboardTab key={tab.value} tab={tab} tabId={tabId} dashboard={dashboard} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardGroupDropdownTabRowMenu;

const DashboardTab = ({
  tab,
  tabId,
  dashboard,
}: {
  tab: SelectItem;
  tabId: number | undefined;
  dashboard: Dashboard;
}) => {
  const selectedIndex = dashboard.dashboardTabsJs.findIndex(t => t.uuid === tab.value);
  return (
    <Link
      key={tab.value}
      to={`/dashboard/${dashboard.id}/tab/${selectedIndex}`}
      className={`tab dashboard-tab ${
        tabId !== undefined && tabId === selectedIndex ? "tab-selected" : "tab-unselected"
      } ${selectedIndex === 0 ? "first-tab" : ""} ${selectedIndex === dashboard.dashboardTabsJs.length - 1 ? "last-tab" : ""}`}
      data-text={tab.label}
    >
      {tab.label}
    </Link>
  );
};
